<section *ngIf="onReady && gotData" class="sk-overview-container">
  <div
    class="sk-breadcrumb-container"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div
      class="sk-breadcrumb-links-row"
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start"
    >
      <a routerLink="/office"> <mat-icon>home</mat-icon> </a>
      <mat-icon>chevron_right</mat-icon>
      <a routerLink="/office/invoicing/overview" routerLinkActive="active">Invoicing</a>
      <mat-icon>chevron_right</mat-icon>
      <div>Display</div>
    </div>
    <div class="sk-breadcrumb-action-row" fxLayout="row" fxLayoutAlign="end">
      <button
        mat-icon-button
        [matMenuTriggerFor]="invoicemenu"
        matTooltip="Invoice Actions"
        matTooltipShowDelay="1000"
      >
        <mat-icon color="primary">more_vert</mat-icon>
      </button>
      <mat-menu #invoicemenu="matMenu">
        <button
          mat-menu-item
          matTooltip="Pay invoice"
          matTooltipShowDelay="1000">
          <mat-icon color="primary">attach_money</mat-icon>
          <span>Pay Invoice</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <mat-toolbar>
    <h1 class="mat-h1">Invoice #{{invoice?.invoiceNumber}}</h1>
  </mat-toolbar>

  <div fxLayout="column" fxLayoutGap="10px">

    <div fxLayoutGap="10px" fxLayout.gt-sm="row" fxLayout.lt-md="column">
      <mat-card class="sk-dashboard-card">
        <div fxLayout="column">

          <!-- Customer Name and Email -->
          <div>Customer</div>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
            <h4 class="mat-h4">{{ locationLookup[invoice?.locationId].locationName | truncate:50 }}
            </h4>
            <div fxLayout="row" fxLayoutGap="10px">
              <h4 class="mat-h4">Email: </h4>
              <h4 class="mat-h4">{{ locationLookup[invoice?.locationId].locationEmail }}</h4>
            </div>
          </div>

          <!-- Row with invoice info -->
          <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="50px">

            <!-- Address block -->
            <div fxLayout="column">
              <div>Billing Address</div>
              <div fxLayout="row" fxLayoutGap="10px">
                <div>{{ locationLookup[invoice?.locationId].address.street1 }}</div>
                <div>{{ locationLookup[invoice?.locationId].address.street2 }}</div>
              </div>
              <div fxLayout="row" fxLayoutGap="10px">
                <div>{{ locationLookup[invoice?.locationId].address.city }},</div>
                <div>{{ locationLookup[invoice?.locationId].address.state }}</div>
                <div>{{ locationLookup[invoice?.locationId].address.zip }}</div>
              </div>
            </div>

            <!-- Terms -->
            <div fxLayout="column" fxLayoutAlign="start center">
              <div>Terms</div>
              <div class="detail-value-capitalize">{{ invoice?.invoiceTerms.name }}</div>
            </div>

            <!-- Invoice Date -->
            <div fxLayout="column" fxLayoutAlign="start center">
              <div>Invoice Date</div>
              <div class="detail-value-capitalize">{{ invoice?.invoiceDate.toDate() | date:"shortDate" }}</div>
            </div>

            <!-- Due Date -->
            <div fxLayout="column" fxLayoutAlign="start center">
              <div>Due Date</div>
              <div class="detail-value-capitalize">{{ invoice?.dueDate.toDate() | date:"shortDate" }}</div>
            </div>
          </div>

        <sk-invoice-detail [invoiceId]=invoiceId [allowEdit]=false></sk-invoice-detail>

        </div>
      </mat-card>
    </div>
  </div>
</section>


<!-- ToDo : Server side message should be translated -->
